import { render, staticRenderFns } from "./NewTruckZip3Overrides.vue?vue&type=template&id=d6317946"
import script from "./NewTruckZip3Overrides.vue?vue&type=script&lang=ts"
export * from "./NewTruckZip3Overrides.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports